import { render, staticRenderFns } from "./GrupoUsuarioSelect.vue?vue&type=template&id=7b609ca6"
import script from "./GrupoUsuarioSelect.vue?vue&type=script&lang=js"
export * from "./GrupoUsuarioSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports